import { SerializedNodes } from "@craftjs/core";

export const FixedPage: SerializedNodes = {
    ROOT: {
        type: { resolvedName: "Page" },
        isCanvas: true,
        props: { title: "Untitled Page", language: "int-en", pageType: "Master" },
        displayName: "Page",
        custom: { displayName: "Page" },
        hidden: false,
        nodes: [],
        linkedNodes: {},
        parent: null,
    },
};
